<app-modal>
    <ng-container title>
        {{ 'FEATURES.MEASUREMENTS.TITLES.MOVE_MEASUREMENTS' | translate }}
    </ng-container>
    <ng-container body>
        <app-form-section>
            <app-form-row>
                <app-form-group>
                    <label for="selectedLocationId">{{
                        'FEATURES.MEASUREMENTS.TEXTS.SELECT_LOCATION_FOR_MOVE' | translate
                    }}</label>
                    <app-dropdown
                        [items]="(locationItems$ | async) || []"
                        [placeholder]="'FEATURES.MEASUREMENTS.SELECT_LOCATION' | translate"
                        [searchable]="true"
                        [(ngModel)]="selectedLocationId"
                        [disabled]="isSaving"
                    />
                </app-form-group>
            </app-form-row>
        </app-form-section>
    </ng-container>
    <ng-container footer>
        <button type="button" (click)="onCancel()" [disabled]="isSaving" ngbAutofocus>
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button type="button" class="primary" (click)="onConfirm()" [disabled]="!selectedLocationId || isSaving">
            <span class="material-symbols-rounded leading" [class.spinner]="isSaving">{{
                isSaving ? 'progress_activity' : ''
            }}</span>
            {{ 'BUTTONS.CONFIRM' | translate }}
        </button>
    </ng-container>
</app-modal>
